import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/slice";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context2, _context3; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context2 = ownKeys(Object(t), !0)).call(_context2, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context3 = ownKeys(Object(t))).call(_context3, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//@ts-nocheck
import React from "react";
import { ButtonGroup, Button, Icon, Popper, Paper, ClickAwayListener, MenuList, MenuItem } from "components/mui";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export var ButtonWithDropdown = function ButtonWithDropdown(_ref) {
  var _context;
  var options = _ref.options,
    buttonGroupProps = _ref.buttonGroupProps;
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    open = _React$useState2[0],
    setOpen = _React$useState2[1];
  var anchorRef = React.useRef(null);
  var handleClose = function handleClose() {
    setOpen(false);
  };
  var handleToggle = function handleToggle() {
    setOpen(function (prevOpen) {
      return !prevOpen;
    });
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(ButtonGroup, _objectSpread(_objectSpread({
      variant: "primaryButton",
      ref: anchorRef
    }, buttonGroupProps), {}, {
      children: [/*#__PURE__*/_jsx(Button, {
        onClick: options[0].handle,
        variant: buttonGroupProps === null || buttonGroupProps === void 0 ? void 0 : buttonGroupProps.variant,
        children: options[0].label
      }), /*#__PURE__*/_jsx(Button, {
        size: "small",
        onClick: handleToggle,
        variant: buttonGroupProps === null || buttonGroupProps === void 0 ? void 0 : buttonGroupProps.variant,
        children: /*#__PURE__*/_jsx(Icon, {
          className: "fas fa-caret-down",
          style: {
            fontSize: 12
          },
          "data-testId": "drop-down-expander"
        })
      })]
    })), /*#__PURE__*/_jsx(Popper, {
      open: open,
      anchorEl: anchorRef.current,
      placement: "bottom-start",
      style: {
        zIndex: 3000,
        marginTop: 5
      },
      children: /*#__PURE__*/_jsx(Paper, {
        children: /*#__PURE__*/_jsx(ClickAwayListener, {
          onClickAway: handleClose,
          children: /*#__PURE__*/_jsx(MenuList, {
            children: _mapInstanceProperty(_context = _sliceInstanceProperty(options).call(options, 1)).call(_context, function (option, index) {
              return /*#__PURE__*/_jsx(MenuItem, {
                dense: true,
                onClick: function onClick(event) {
                  return option.handle(event);
                },
                children: option.label
              }, index);
            })
          })
        })
      })
    })]
  });
};